import {
  Divider,
  IconButton,
  Sheet,
  SheetContent,
  SheetTitle,
  Typography,
} from "@suraasa/placebo-ui"
import clsx from "clsx"
import PageContainer from "components/PageContainer"
import { Xmark } from "iconoir-react"

import Banner from "./assets/banner.png"

const steps = [
  {
    title: "Learner Submits Skill Evidence (Assignment)",
    stepColor: "#4B83EE",
    titleColor: "#1148B3",
    content:
      "After the completion of a course / milestone, learners are allotted assignments with defined rubrics. The learners write them digitally and submit on Suraasa.",
  },
  {
    title: "Plagiarism Check",
    stepColor: "#4785D0",
    titleColor: "#23528B",
    content:
      "After the learner submits the assignment, our advances plagiarism detection systems check the assignments for plagiarism against other assignments as well as related articles on the internet. If any assignment fails this check, learners are required to redo the assignment.",
  },
  {
    title: "Marked by Professor",
    stepColor: "#4487B2",
    titleColor: "#2A546F",
    content:
      "Once plagiarism check is cleared, our experienced international professors evaluate the assignment based on carefully defined rubrics. If a learner's assignment isn't upto the required standards, they have to redo the assignment.",
  },
  {
    title: "Quality Assured by Us",
    stepColor: "#428893",
    titleColor: "#29555C",
    content:
      "After evaluation by the professors, we run the assignment through a quality assurance process to double-check its authenticity and validity. This helps us to also ensure fairness in evaluation.",
  },
  {
    title: "Skill Evidence (Assignment) Checked Successfully",
    stepColor: "#408B76",
    titleColor: "#28574A",
    content:
      "Only after it clears the above 4 steps, the assignment is successfully verified and added to the learner's skill portfolio.",
  },
]

const Stepper = () => {
  return (
    <div>
      {steps.map((step, index) => (
        <div className="flex" key={index}>
          <div>
            <div
              className={clsx("h-full w-px translate-y-2.25 bg-onSurface-300", {
                "opacity-0": index === steps.length - 1,
              })}
            />
          </div>

          <div>
            <div className="size-1.25 translate-x-[-55%] translate-y-2.25 rounded-full bg-onSurface-300 " />
            <div className="mb-3 ml-2.5">
              <Typography
                className="mb-0.25"
                style={{ color: step.stepColor }}
                variant="title2"
              >
                {(index + 1).toString().padStart(2, "0")}
              </Typography>
              <Typography
                className="mb-0.25"
                style={{ color: step.titleColor }}
                variant="strong"
              >
                {step.title}
              </Typography>
              <Typography variant="smallBody">{step.content}</Typography>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

const VerificationProcess = ({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) => {
  return (
    <Sheet open={open}>
      <SheetContent height={100} className="overflow-y-scroll">
        <SheetTitle className="border-b">
          <PageContainer>
            <span className="flex items-center justify-between py-1.5">
              <img
                src="https://assets.suraasa.com/logos/v2/mini.webp"
                alt="suraasa logo"
                width={40}
                height={40}
              />
              <IconButton
                className="flex size-[27px] items-center justify-center rounded-full border-2 border-onSurface-500"
                onClick={onClose}
              >
                <Xmark className="text-onSurface-500" />
              </IconButton>
            </span>
          </PageContainer>
        </SheetTitle>

        <div>
          <div className="m-auto w-[800px] max-w-full">
            <img alt="banner" className="my-4 w-full" src={Banner} />
            <Divider weight="light" />
          </div>
          <div className={clsx("m-auto max-w-[580px]", "p-3")}>
            <Typography className="my-3 text-primary-800" variant="title1">
              How Suraasa verifies every single skill evidence (assignment)
            </Typography>
            <Stepper />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default VerificationProcess
